module.exports = __webpack_public_path__ + "media/images/twitter-icon@2x-df0860ad4d52c4588e72f5f8f55b7721.png";